import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import { ExternalDataHandler } from './ExternalDataHandler';
import { ExternalStylesHandler } from './ExternalStylesHandler';
import { ExternalStateHandler } from './ExternalStateHandler';
import { ExternalPresetsHandler } from './ExternalPresetsHandler';
import { ExternalResolvedDataHandler } from './ExternalResolvedDataHandler';
import { ExternalStageHandler } from './ExternalStageHandler';
import { ExternalLayoutHandler } from './ExternalLayoutHandler';
var _handlerParameters = /*#__PURE__*/new WeakMap();
var _data = /*#__PURE__*/new WeakMap();
var _styles = /*#__PURE__*/new WeakMap();
var _state = /*#__PURE__*/new WeakMap();
var _presets = /*#__PURE__*/new WeakMap();
var _resolvedData = /*#__PURE__*/new WeakMap();
var _stage = /*#__PURE__*/new WeakMap();
var _layout = /*#__PURE__*/new WeakMap();
export class ExternalAPIHandlers {
  constructor(dm, hostAPI, manifestStore, manifestDefaultValues) {
    this.dm = dm;
    this.hostAPI = hostAPI;
    this.manifestStore = manifestStore;
    this.manifestDefaultValues = manifestDefaultValues;
    _classPrivateFieldInitSpec(this, _handlerParameters, [this.dm, this.hostAPI, this.manifestStore]);
    _classPrivateFieldInitSpec(this, _data, new ExternalDataHandler(..._classPrivateFieldGet(_handlerParameters, this), this.manifestDefaultValues));
    _classPrivateFieldInitSpec(this, _styles, new ExternalStylesHandler(..._classPrivateFieldGet(_handlerParameters, this), this.manifestDefaultValues));
    _classPrivateFieldInitSpec(this, _state, new ExternalStateHandler(..._classPrivateFieldGet(_handlerParameters, this)));
    _classPrivateFieldInitSpec(this, _presets, new ExternalPresetsHandler(..._classPrivateFieldGet(_handlerParameters, this)));
    _classPrivateFieldInitSpec(this, _resolvedData, new ExternalResolvedDataHandler(..._classPrivateFieldGet(_handlerParameters, this)));
    _classPrivateFieldInitSpec(this, _stage, new ExternalStageHandler(..._classPrivateFieldGet(_handlerParameters, this)));
    _classPrivateFieldInitSpec(this, _layout, new ExternalLayoutHandler(..._classPrivateFieldGet(_handlerParameters, this)));
    _defineProperty(this, "query", {
      data: _classPrivateFieldGet(_data, this),
      resolvedData: _classPrivateFieldGet(_resolvedData, this),
      styles: _classPrivateFieldGet(_styles, this),
      state: _classPrivateFieldGet(_state, this),
      presets: _classPrivateFieldGet(_presets, this),
      layout: _classPrivateFieldGet(_layout, this)
    });
    _defineProperty(this, "resolver", {
      state: _classPrivateFieldGet(_state, this),
      presets: _classPrivateFieldGet(_presets, this),
      stage: _classPrivateFieldGet(_stage, this)
    });
  }
}
//# sourceMappingURL=ExternalAPIHandlers.js.map